import React, { useState } from "react";
import { Table, Collapse, Card  } from "antd";
import moment from "moment";
import Pageloader from "../../../../components/loader";
import { getRiderStatusLog } from "../../../../services/riders.service";
import { validationErrors } from "../../../../utils/Helpers";

const { Panel } = Collapse;
const pagename = "Status Log";

const RiderStatusLog = (props) => {
  const [postData, setPostData] = useState(null);
  const [postDataPagi, setPostDataPagi] = useState(null);
  const [loading, setLoading] = useState(false);

  const postLists = async (page=1, limit=10) => {
    let dataFilter = {
      id: props?.RiderID,
      page: page,
      limit: limit,
    }
    try {
      setLoading(true);
      const {data} = await getRiderStatusLog(dataFilter);
      setPostData(data?.data);
      setPostDataPagi(data?.pagination)
    } catch (e) {
      validationErrors(e);
    } finally {
      setLoading(false);
    }
  };

  const paginationChange = async (page, limit) => {
    postLists(page, limit);
  };

  const postColumns = [
    {
      title: "Previous status",
      dataIndex: "current_status",
      render: (value) => (value || '-'),
    },
    {
      title: "New status",
      dataIndex: "status",
      render: (value) => (value || '-'),
    },
    // {
    //   title: "Date & Time of status change",
    //   dataIndex: "previous_status",
    //   render: (value) => (value || '-'),
    // },
    {
      title: "User ID",
      dataIndex: "users",
      // render: (value) => (value?.id || '-'),
      render: (value) => {
        return value ? <><span>{value?.id}</span><p>{value?.name}</p></> : '-';
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      render: (value) => {
        return value ? <><span>{moment(value).format("DD MMMM, yyyy")}</span><p>{moment(value).format("h:mm A")}</p></> : '-';
      },
    },
  ];
  
  return (
    <Card title={pagename} bordered>
      <Collapse onChange={postData===null?()=>postLists(1,10):()=>{}}>
        <Panel header={pagename}>
          {loading ? <Pageloader/> : <Table
            dataSource={postData}
            columns={postColumns}
            // onRow={(r)=>({onDoubleClick:()=>window.open(`/overview/${r._id}`)})}
            pagination={{
              total: postDataPagi?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: postDataPagi?.limit,
              defaultCurrent: postDataPagi?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (currentPage, pageSize) => {
                paginationChange(currentPage, pageSize);
              },
            }}
          />}
        </Panel>
        </Collapse>
    </Card>
  );
};

export default RiderStatusLog;
